import React, { useContext, useCallback } from "react";
import { useForm } from "react-hook-form";

import Button from '@mui/material/Button';
import Form from 'react-bootstrap/Form';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import FlagIcon from '@mui/icons-material/Flag';
import OutlinedFlagIcon from '@mui/icons-material/OutlinedFlag';

import { saveNote } from "../service";
import Context from "../context";
import { theme } from "../../../../theme";
import SetFollowupReminder from "./setFollowupReminder";

const Footer = ({ ftm_id, onRefreshData }) => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm()

    const context = useContext(Context);

    const refreshFooter = useCallback(() => {
        if (onRefreshData) {
            onRefreshData(); // This will re-execute the API call in index
        }
    }, [onRefreshData]);

    return (
        <div className="offcanvas-footer">
            <div className="container">
                <div className="row" style={{ marginTop: '10px' }}>
                    <div className="col">
                        <div className="d-grid gap-2 mb-3">
                            <Form onSubmit={handleSubmit((data) => saveNote(data, ftm_id, context.dispatch, reset))} style={{ textAlign: 'center' }}>
                                <FormControl error={errors.note} fullWidth className="mb-3">
                                    <TextField
                                        error={errors.note}
                                        placeholder="Enter your note"
                                        size="small"
                                        type="text"
                                        multiline
                                        rows={4}
                                        InputProps={{
                                            style: { backgroundColor: '#fff' },
                                        }}
                                        {...register("note", { required: true })}
                                    />
                                    {errors.note && <FormHelperText>Note is required</FormHelperText>}
                                </FormControl>

                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Button type="submit" variant="contained" color={theme.main} fullWidth>
                                        SAVE
                                    </Button>
                                    <Tooltip title={context.state.notes_list[0]?.ftm?.ftm_is_notes_followup === 1 ? "Unmark follow up" : "Mark for follow up"} arrow>
                                        <Checkbox
                                            icon={<OutlinedFlagIcon />}
                                            checkedIcon={<FlagIcon color="warning" />}
                                            defaultChecked={context.state.notes_list[0]?.ftm?.ftm_is_notes_followup === 1 ? true : false}
                                            {...register("ftm_is_notes_followup", { required: false })}
                                        />
                                    </Tooltip>
                                    <SetFollowupReminder
                                        ftm_id={ftm_id}
                                        ftm_notes_followup_reminder_date={context.state.notes_list[0]?.ftm?.ftm_notes_followup_reminder_date}
                                        onSave={refreshFooter}
                                    />
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;